export const environment = {
  production: false,
  siteId: 'avrax-group',
  externalApiUrl: 'http://localhost:3501/api/v1',
  apiAccessKey: 'ak_5e63a121cf0027048a3f2fae9f9979c6',
  apiSecretKey: 'sk_e2f98084b3b06fa5291c3e06229adeeff6e427bf1a4b46f6eb958f1af6f8d481',
};
